import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Navbar, Container, Nav } from 'react-bootstrap'
import HomeIcon from '@mui/icons-material/Home'
import './Header.css'
import { NavLink, useLocation } from 'react-router-dom'
import ProfileData from './../../utils/ProfileData'
import CustomButton from '../Button/CustomButton'
import TelegramIcon from '@mui/icons-material/Telegram';

const Header = () => {
  const location = useLocation()
  const pathName = location.pathname
  return (
    <Navbar bg='light' expand='lg' className='home-bar b2' sticky='top'>
       <Container >
          <Navbar.Brand className='home-icon'>
          <Nav.Link as={NavLink} to='/'>
            <HomeIcon id='home-icon' />
          </Nav.Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto'>
            <Nav.Link
              as={NavLink}
              to='/resume'
              className={pathName === '/resume' ? 'head-link' : 'inactive-link'}
            >
              Resume
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/portfolio'
              className={
                pathName === '/portfolio' ? 'head-link' : 'inactive-link'
              }
            >
              Portfolio
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/contact'
              className={
                pathName === '/contact' ? 'head-link' : 'inactive-link'
              }
            >
              Contact
            </Nav.Link>
          </Nav>
          <div className='right-nav'>
            {Object.keys(ProfileData.socials).map((key,id=1) => {
              return (
                <a key ={id++}href={ProfileData.socials[key].link} target='_blank' rel="noreferrer" className="social-icon">
                  {ProfileData.socials[key].icon}
                </a>
              )
            })}
          </div>
            <div className="flex-hire">
              <a href="mailto:tee.jhay1@gmail.com" style={{textDecoration:'none'}}>
            <CustomButton text='Hire Me' icon={<TelegramIcon />}/>
              </a>
            </div>
        </Navbar.Collapse>
       </Container>
    </Navbar>
  )
}

export default Header
